export const LOCALE_TYPE = {
  EN: 'en',
  RU: 'ru',
};
